import { useState } from 'react';

import type { BotState } from '../../types';

// isBotCheckDone: this is to check if the cloudflare bot check api call has been completed
// isRenderRecaptchaStarted: this is to check if rendering recaptcha has been started
// isRenderRecaptchaDone: this is to check if rendering recaptcha has been completed

export const useBotState = () =>
  useState<BotState>({
    isBotCheckDone: false,
    isRenderRecaptchaStarted: false,
    isRenderRecaptchaDone: false,
  });
